import { useState, useEffect } from 'react';
import Image from 'next/legacy/image';
import ImageWithZoom from './image-with-zoom';
import setImageSize from '../utils/setImageSize';

interface MarkdownImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
}

const MarkdownImage: React.FunctionComponent<MarkdownImageProps> = ({ src, alt, width, height }) => {
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    setImageSize(setImageDimensions, src);
  }, []);

  if (alt?.startsWith('icon:')) {
    return <img src={src} alt={alt} width={width} height={height} />;
  }

  if (width > 800 || imageDimensions.width > 800) {
    return (
      <div className="image-wrapper">
        <ImageWithZoom
          src={src}
          alt={alt}
          width={width || imageDimensions.width}
          height={height || imageDimensions.height}
        />
      </div>
    );
  }

  return (
    <div className="image-wrapper">
      {imageDimensions && (
        <Image
          src={`${src.startsWith('//') ? `https:${src}` : src}`}
          alt={alt || ''}
          width={width || imageDimensions.width}
          height={height || imageDimensions.height}
          layout="intrinsic"
          quality={100}
        />
      )}
    </div>
  );
};

export default MarkdownImage;
